import Icon from '@assets/images/icons/content-icon.svg?react'
import cx from 'classnames'
import type React from 'react'
import type { MouseEvent } from 'react'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { stopPropagationHandler } from '@/helpers'
// @TODO review this and fix
// @ts-expect-error - Module has no exported member 'BlockItem'
import type { BlockItem } from '@/types/models'
import { SearchEntity } from '../../hooks/useSearch'
import css from '../../Result.module.scss'

type Props = {
  blocks: Record<string, BlockItem>
  selectedItemId: string | null
  contentButton?: boolean
  onClick: (entity: SearchEntity, payload: any) => void
  onClickContent?: (entity: SearchEntity, payload: any) => void
  hideTitle?: boolean
}

const Blocks: React.FC<Props> = ({
  blocks,
  selectedItemId,
  contentButton,
  onClick,
  onClickContent,
  hideTitle,
}) => {
  const handleClick = (block: BlockItem) => () => {
    sendGtmEvent(GtmTriggerName.SEARCH_RESULT_CLICK, 'Block result clicked')
    sendGtmEvent(GtmTriggerName.SEARCH_BLOCK_CLICK, 'Block result clicked')
    onClick(SearchEntity.BLOCK, block)
  }

  const handleClickContent =
    (block: BlockItem) => (e: MouseEvent<HTMLButtonElement>) => {
      stopPropagationHandler(e)
      sendGtmEvent(
        GtmTriggerName.SEARCH_RESULT_CLICK,
        'Block content button clicked'
      )
      onClickContent?.(SearchEntity.BLOCK, block)
    }

  return (
    <div>
      {Object.keys(blocks).length > 0 && (
        <div>
          {!hideTitle && <div className={css.title}>Blocks</div>}

          <div className={css.list}>
            {Object.entries(blocks).map(([id, block]) => (
              <div
                key={block.id}
                className={cx(css.item, {
                  [css.selected]: selectedItemId === id,
                })}
                onClick={handleClick(block)}
              >
                <div>{block.title}</div>

                {contentButton && (
                  <button
                    className={css.contentButton}
                    onClick={handleClickContent(block)}
                  >
                    <Icon />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default Blocks
